// Modules
import React from "react";

// Assets
import "./home-improvments.scss";
import CleaningEquipementIcon from "../../assets/img/svg/furnishing/CleaningEquipementIcon";
import IroningIcon from "../../assets/img/svg/furnishing/IroningIcon";
import LaundryIcon from "../../assets/img/svg/furnishing/LaundryIcon";
import OvenIcon from "../../assets/img/svg/furnishing/OvenIcon";
import WashingMachineIcon from "../../assets/img/svg/furnishing/WashingMachineIcon";
import FridgeIcon from "../../assets/img/svg/furnishing/FridgeIcon";
import HotplateIcon from "../../assets/img/svg/furnishing/HotplateIcon";
import MicrowaveIcon from "../../assets/img/svg/furnishing/MicrowaveIcon";
import DishwasherIcon from "../../assets/img/svg/furnishing/DishwasherIcon";
import TablewareIcon from "../../assets/img/svg/furnishing/TablewareIcon";
import ShowerCurtainIcon from "../../assets/img/svg/furnishing/ShowerCurtainIcon";
import BathMatIcon from "../../assets/img/svg/furnishing/BathMatIcon";
import BathroomEquipmentIcon from "../../assets/img/svg/furnishing/BathroomEquipmentIcon";
import TableIcon from "../../assets/img/svg/furnishing/TableIcon";
import SofaIcon from "../../assets/img/svg/furnishing/SofaIcon";
import CoffeeTableIcon from "../../assets/img/svg/furnishing/CoffeeTableIcon";
import TvIcon from "../../assets/img/svg/furnishing/TvIcon";
import TvCabinetIcon from "../../assets/img/svg/furnishing/TvCabinetIcon";
import CarpetIcon from "../../assets/img/svg/furnishing/CarpetIcon";
import InteriorChairsIcon from "../../assets/img/svg/furnishing/InteriorChairsIcon";
import BedIcon from "../../assets/img/svg/furnishing/BedIcon";
import ClosetIcon from "../../assets/img/svg/furnishing/ClosetIcon";
import DeskIcon from "../../assets/img/svg/furnishing/DeskIcon";
import PlantIcon from "../../assets/img/svg/furnishing/PlantIcon";
import FootstoolIcon from "../../assets/img/svg/furnishing/FootstoolIcon";
import ExteriorChairsIcon from "../../assets/img/svg/furnishing/ExteriorChairsIcon";
import SunshadeIcon from "../../assets/img/svg/furnishing/SunshadeIcon";
// V3
// import BarbecueIcon from "../../assets/img/svg/furnishing/BarbecueIcon";

const Furnitures = (props) => {
  const { currentRoom } = props;
  const furnitures = {
    buanderie: {
      cleaning_equipment: {
        label: "Matériel de ménage",
        isOptional: false,
        icon: <CleaningEquipementIcon />,
      },
      ironing: {
        label: "Nécessaire de repassage",
        isOptional: false,
        icon: <IroningIcon />,
      },
      laundry: {
        label: "Étendoir à linge et cintres",
        isOptional: false,
        icon: <LaundryIcon />,
      },
    },
    cuisine: {
      oven: {
        label: "Four",
        isOptional: false,
        icon: <OvenIcon />,
      },
      washing_machine: {
        label: "Lave linge",
        isOptional: true,
        icon: <WashingMachineIcon />,
      },
      fridge: {
        label: "Réfrigérateur",
        isOptional: false,
        icon: <FridgeIcon />,
      },
      hotplate: {
        label: "Plaque de cuisson",
        isOptional: false,
        icon: <HotplateIcon className="hotplate" />,
      },
      microwave: {
        label: "Four micro-ondes",
        isOptional: false,
        icon: <MicrowaveIcon />,
      },
      dishwasher: {
        label: "Lave-vaisselle",
        isOptional: true,
        icon: <DishwasherIcon />,
      },
      tableware: {
        label: "Vaisselle et ustensiles de cuisine",
        isOptional: false,
        icon: <TablewareIcon className="tableware" />,
      },
    },
    salle_de_bain: {
      shower_curtain: {
        label: "Rideau de douche",
        isOptional: false,
        icon: <ShowerCurtainIcon />,
      },
      bath_mat: {
        label: "Tapis de bain",
        isOptional: false,
        icon: <BathMatIcon />,
      },
      equipment: {
        label: "Équipements et accessoires de salle de bain",
        isOptional: false,
        icon: <BathroomEquipmentIcon className="bathroom-equipment" />,
      },
    },
    salon: {
      table: {
        label: "Table",
        isOptional: false,
        icon: <TableIcon />,
      },
      sofa: {
        label: "Canapé",
        isOptional: false,
        icon: <SofaIcon />,
      },
      coffee_table: {
        label: "Table basse",
        isOptional: false,
        icon: <CoffeeTableIcon />,
      },
      tv: {
        label: "Téléviseur",
        isOptional: false,
        icon: <TvIcon />,
      },
      tv_cabinet: {
        label: "Meuble TV",
        isOptional: false,
        icon: <TvCabinetIcon />,
      },
      carpet: {
        label: "Tapis",
        isOptional: false,
        icon: <CarpetIcon />,
      },
      chairs: {
        label: "Chaises",
        isOptional: false,
        icon: <InteriorChairsIcon />,
      },
    },
    chambre: {
      bed: {
        label: "Lit",
        isOptional: false,
        icon: <BedIcon />,
      },
      closet: {
        label: "Armoire",
        isOptional: false,
        icon: <ClosetIcon />,
      },
      desk: {
        label: "Bureau et fauteuil",
        isOptional: false,
        icon: <DeskIcon />,
      },
    },
    balcon: {
      table: {
        label: "Table",
        isOptional: true,
        icon: <TableIcon />,
      },
      plant: {
        label: "Plante artificielle",
        isOptional: false,
        icon: <PlantIcon />,
      },
      footstool: {
        label: "Pouf",
        isOptional: false,
        icon: <FootstoolIcon />,
      },
      chairs: {
        label: "Chaises",
        isOptional: false,
        icon: <ExteriorChairsIcon />,
      },
    },
    terrasse: {
      table: {
        label: "Table",
        isOptional: false,
        icon: <TableIcon />,
      },
      plant: {
        label: "Plante artificielle",
        isOptional: false,
        icon: <PlantIcon />,
      },
      footstool: {
        label: "Pouf",
        isOptional: false,
        icon: <FootstoolIcon />,
      },
      chairs: {
        label: "Chaises",
        isOptional: false,
        icon: <ExteriorChairsIcon />,
      },
      sunshade: {
        label: "Parasol",
        isOptional: false,
        icon: <SunshadeIcon />,
      },
    },
    // V3
    // jardin: {
    //   table: {
    //     label: "Table",
    //     isOptional: false,
    //     icon: <TableIcon />,
    //   },
    //   plant: {
    //     label: "Plante artificielle",
    //     isOptional: false,
    //     icon: <PlantIcon />,
    //   },
    //   footstool: {
    //     label: "Pouf",
    //     isOptional: false,
    //     icon: <FootstoolIcon />,
    //   },
    //   chairs: {
    //     label: "Chaises",
    //     isOptional: false,
    //     icon: <ExteriorChairsIcon />,
    //   },
    //   sunshade: {
    //     label: "Parasol",
    //     isOptional: false,
    //     icon: <SunshadeIcon />,
    //   },
    //   barbecue: {
    //     label: "Barbecue",
    //     isOptional: false,
    //     icon: <BarbecueIcon />,
    //   },
    // },
  };

  return (
    Object.keys(furnitures).map((room) => {
      if (currentRoom.toLowerCase().includes(room)
        || (currentRoom === "Salle de bain" && room === "salle_de_bain")) {
        if (currentRoom === "Salon / Chambre" && room === "salon")
          return null;
        return Object.keys(furnitures[room]).map((item) => (
          <li className="furniture-item" key={furnitures[room][item].label}>
            {furnitures[room][item].icon}
            <p>{furnitures[room][item].label}</p>
          </li>
        ));
      }
      return null;
    })
  );
};

export default Furnitures;